
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import template from './event-summary.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Components/Event Summary" mdxType="Meta" />
    <h1>{`Event Summary`}</h1>
    <p>{`Combines the `}<a parentName="p" {...{
        "href": "/docs/objects-media--image"
      }}>{`Media object`}</a>{` and `}<a parentName="p" {...{
        "href": "/docs/components-calendar-date--basic"
      }}>{`Calendar Date component`}</a>{` to display information for an upcoming speaking event.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Default" args={{
        datetime: '2021-10-03',
        event: 'Smashing Magazine',
        note: '3 day event',
        location: 'New York, NY',
        speakers: ['Megan', 'Aileen'],
        href: 'https://cloudfour.com'
      }} mdxType="Story">
    {args => template(args)}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`class`}</inlineCode>{` (string): Append a class to the `}<inlineCode parentName="li">{`c-event-summary`}</inlineCode>{` root element.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`heading_level`}</inlineCode>{` (number, default `}<inlineCode parentName="li">{`3`}</inlineCode>{`): The header heading level (e.g. `}<inlineCode parentName="li">{`2`}</inlineCode>{` renders an `}<inlineCode parentName="li">{`<h2>`}</inlineCode>{` element).`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`datetime`}</inlineCode>{` (string): Refer to the `}<a parentName="li" {...{
          "href": "/docs/components-calendar-date--basic#template-properties"
        }}>{`Calendar Date component`}</a></li>
      <li parentName="ul"><inlineCode parentName="li">{`event`}</inlineCode>{` (string): The name of the event (e.g. `}<inlineCode parentName="li">{`'Smashing Magazine'`}</inlineCode>{`)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`href`}</inlineCode>{` (string): The event URL (e.g. `}<inlineCode parentName="li">{`https://cloudfour.com`}</inlineCode>{`)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`location`}</inlineCode>{` (string): The location of the event (e.g. `}<inlineCode parentName="li">{`'Portland, OR'`}</inlineCode>{`)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`note`}</inlineCode>{` (string): A short event note (e.g. "3 day event")`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`speakers`}</inlineCode>{` (string array): An array of string names of the speakers:`}
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-ts"
          }}>{`['Megan', 'Aileen'];
`}</code></pre>
      </li>
    </ul>
    <h2>{`Template blocks`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`note`}</inlineCode>{` (optional): Refer to the `}<a parentName="li" {...{
          "href": "/docs/components-calendar-date--basic#template-blocks"
        }}>{`Calendar Date component`}</a></li>
      <li parentName="ul"><inlineCode parentName="li">{`event_details`}</inlineCode>{` (optional): Overrides default event details section (location & speakers)`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const defaultStory = (args => template(args));
defaultStory.storyName = 'Default';
defaultStory.args = {
  datetime: '2021-10-03',
  event: 'Smashing Magazine',
  note: '3 day event',
  location: 'New York, NY',
  speakers: ['Megan', 'Aileen'],
  href: 'https://cloudfour.com'
};
defaultStory.parameters = { storySource: { source: 'args => template(args)' } };

const componentMeta = { title: 'Components/Event Summary', includeStories: ["defaultStory"],  };

const mdxStoryNameToKey = {"Default":"defaultStory"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;